<section class="panel popup-panel panel-account" [@onSidePanelStatusChange]="statusPanel" (onClickOutside)="closePanel()">
  <div class="panel-side">
    <div class="panel-info">
      <span class="avatar avatar-panel size-64">
        <figure [style.background-image]="'url(' + userPicture + ')'"></figure>
      </span>
      <div class="user-profile">
        <label class="typo body-1 fw600 condensed user-name">{{ userFirstName }} {{ userLastName }} <span class="badge">{{ userRole }}</span></label>
        <label class="typo body-1 fw400 condensed">{{ companyName }}</label>
      </div>
    </div>
    <div class="panel-nav">
      <mat-list class="custom-mat-list list-navigation-panel">
        <!-- <button mat-flat-button color="primary" class="custom-mat-flat-button" (click)="openAccountSettings()">Edit Profile</button> -->
        <a mat-list-item [routerLink]="['/login/switch']" class="custom-mat-list-item">Switch Company<mat-icon svgIcon="ico-switch" class="custom-mat-icon ico-size ico-1xs"></mat-icon></a>
        <a mat-list-item (click)="closePanel()" [routerLink]="['/account']" class="custom-mat-list-item">Account<mat-icon svgIcon="ico-account" class="custom-mat-icon ico-size ico-1xs"></mat-icon></a>
        <a mat-list-item (click)="closePanel()" [routerLink]="['/main/settings/advanced']" class="custom-mat-list-item">Advanced Settings<mat-icon svgIcon="ico-settings" class="custom-mat-icon ico-size ico-1xs"></mat-icon></a>
        <a mat-list-item (click)="signOut()" class="custom-mat-list-item">Log Out<mat-icon svgIcon="ico-signout" class="custom-mat-icon ico-size ico-1xs"></mat-icon></a>
      </mat-list>
    </div>
    <div class="panel-legal">
      <a class="custom-mat-link link">Privacy</a><span class="divider">and</span><a class="custom-mat-link link">Terms</a>
    </div>
  </div>
  <div class="panel-side side-upgrade">
    <mat-icon svgIcon="ico-rocket" class="custom-mat-icon ico-size ico-92"></mat-icon>
    <h1 class="typo title fw400 semi-condensed">Upgrade your account</h1>
    <p class="typo label fw300 semi-condensed">See the benefits and maximize your business with the right features for your e-commerce and needs. Upgrade your current plan</p>
    <button mat-flat-button color="primary" class="custom-mat-button button-call-to-action rounded">See our plans</button>
  </div>
</section>
